import { ReactElement } from 'react';

import type { GetServerSideProps } from 'next';
import dynamic from 'next/dynamic';
import Cookies from 'universal-cookie';

import { LoginLayout } from '@/components/layouts-and-navs/landing/LoginLayout';
import Spinner from '@/components/Spinner';

const DynamicEmbeddedWidget = dynamic(() => import('@dynamic-labs/sdk-react-core').then((module) => module.DynamicEmbeddedWidget), {
  loading: () => (
    <div className='size-16 mx-auto'>
      <Spinner />
    </div>
  ),
  ssr: false,
});

const Login = () => {
  return (
    <LoginLayout>
      <DynamicEmbeddedWidget background='default' />
    </LoginLayout>
  );
};

export const getServerSideProps = (async (context) => {
  const cookies = new Cookies(context.req.headers.cookie);
  const isAuth = cookies.get('_token');

  if (isAuth) {
    return {
      redirect: {
        destination: '/portfolio',
        permanent: false,
      },
    };
  }

  return {
    props: {},
  };
}) satisfies GetServerSideProps;

Login.getLayout = (page: ReactElement) => page;

export default Login;
